import { BaseQueryApi } from "@reduxjs/toolkit/query";
import envSettings from "../../../services/system/envSettings";
import { ZodSchema } from "zod/lib/types";
import { validateResult, serveResult } from "../../../services/api/serveApiResponseResult";
import { RefreshTokenResponse, refreshTokenResponseSchema } from "../../../models/authentication/refreshTokenResponse";
import { TBaseQuery } from "../../../models/baseQueries/baseQuery";
import { TransactionIdScopeType } from "../../../enums/transactionIdScopeType";

export const refreshTokenExtension = async (
  baseQuery: TBaseQuery,
  queryApi: BaseQueryApi,
  extraOptions: { dataSchema?: ZodSchema; transactionIdScopeType?: TransactionIdScopeType }
) => {
  const currentEndpoint = queryApi.endpoint;
  queryApi.endpoint = "refreshToken";
  const result = await baseQuery(
    {
      url: `${envSettings.UTILS_API_URL}/${envSettings.REFRESH_TOKEN}`,
      method: "POST",
    },
    queryApi,
    { ...extraOptions, transactionIdScopeType: TransactionIdScopeType.SystemScope }
  );
  queryApi.endpoint = currentEndpoint;
  validateResult(result, refreshTokenResponseSchema);
  return serveResult<RefreshTokenResponse>(result);
};
